import { atom } from "recoil";


const LanguageAtom = atom({
    default: 'it',
    key: 'languageAtomKey'
})

export default LanguageAtom;